module.exports = __webpack_public_path__ + "img/banner_cf_30.6e340d4f.png";